import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main_div" }
const _hoisted_2 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "table-container" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_7 = { style: {"margin":"0 10px"} }
const _hoisted_8 = {
  key: 0,
  class: "organization-details-content"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  style: {"text-align":"center","padding":"20px","color":"#888"}
}
const _hoisted_11 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_12 = {
  key: 0,
  style: {"margin-top":"5px","color":"#888"}
}
const _hoisted_13 = {
  key: 1,
  style: {"margin-top":"5px","color":"#888"}
}
const _hoisted_14 = { style: {"display":"flex","justify-content":"flex-end","margin-top":"20px"} }
const _hoisted_15 = { style: {"text-align":"right","margin-top":"20px"} }

import { ref, onMounted, h, nextTick, computed } from "vue";
import { getCallable } from "@/config/env";
import {
    NCheckboxGroup,
    NCheckbox,
    NSpace,
    NCard,
    NDataTable,
    NButton,
    NModal,
    NDescriptions,
    NDescriptionsItem,
    NForm,
    NFormItem,
    NInput,
    NInputNumber,
    NInputGroup,
    NSelect,
    FormInst,
    FormRules,
    NIcon,
    NSpin,
    useMessage,
    useNotification,
    useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import * as common from "@/assets/common/common";
import { useAuth } from "@/composables/useAuth";
import { usePagination } from "@/composables/usePagination";
import { Product, ProductGroup } from "@/model/product";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductGroup',
  setup(__props) {

const { loading } = useAuth(); // 전역 로딩 상태
const componentKey = ref(0); // To force re-render if needed
const getProductGroupsCallable = getCallable("getProductGroups");
const updateProductGroupCallable = getCallable("updateProductGroup");
const addProductGroupCallable = getCallable("addProductGroup");
const getOrganizationProductsCallable = getCallable("getProducts");

const tempSelectedOrgProductId = ref<string | null>(null);
const selectedProductCategory = ref<string | null>(null);
const organizationProducts = ref<Proudct[]>([]);

const productCategories = ref([
    { label: "진단 검사", value: "personal" },
    { label: "집단분석", value: "org" },
    { label: "상담코칭", value: "offline" },
    { label: "Activity", value: "activity" },
    { label: "전문가교육", value: "expert" },
]);
const organizationProductsOptions = computed(() => {
    if (!selectedProductCategory.value) {
        return [];
    }
    const categoryPrefix = selectedProductCategory.value + "#";
    return organizationProducts.value
        .filter((prod) => prod.SK && prod.SK.startsWith(categoryPrefix))
        .map((prod) => ({
            ...prod,
            disabled: false,
        }));
});

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const router = useRouter();
const orgProductLoading = ref(false);

const {
    paginatedItems: productGroups,
    listLoading,
    error,
    currentPage,
    hasNextPage,
    goToNextPage: composableGoToNextPage,
    goToPreviousPage: composableGoToPreviousPage,
    refreshData: composableRefreshProductGroups,
} = usePagination<ProductGroup>(async (params) => getProductGroupsCallable(params), 10);

async function wrappedRefreshProductGroups() {
    await composableRefreshProductGroups();
}

const selectedProductGroup = ref<ProductGroup | null>(null);
const showDetailsModal = ref<boolean>(false);

const showGroupRegistrationModal = ref(false);
const groupRegistrationFormRef = ref<FormInst | null>(null);
const groupRegistrationModel = ref<{
    product_key: string;
    name: string;
    price: number | null;
    description: string;
    products: Product[];
}>({
    product_key: "",
    name: "",
    price: null,
    description: "",
    products: [],
});
const isGroupRegistering = ref(false);

const groupRegistrationRules: FormRules = {
    product_key: [
        {
            required: true,
            message: "상품코드를 입력해주세요.",
            trigger: ["input", "blur"],
        },
    ],
    name: [
        {
            required: true,
            message: "상품명을 입력해주세요.",
            trigger: ["input", "blur"],
        },
    ],
    price: [
        { required: true, message: "가격을 입력해주세요." },
        {
            type: "number",
            message: "가격은 숫자여야 합니다.",
            trigger: ["input", "blur"],
        },
    ],
    selectedProductIds: [
        {
            type: "array",
            required: true,
            min: 1,
            message: "하나 이상의 상품을 추가해주세요.",
            trigger: "change",
        },
    ],
};

const showEditModal = ref<boolean>(false);
const editFormRef = ref<FormInst | null>(null);
const editModel = ref<Partial<ProductGroup>>({
    SK: "",
    group_id: "",
    name: "",
    price: 0,
    description: "",
    status: "",
    products: [],
});
const isUpdating = ref<boolean>(false);

const editRules: FormRules = {
    name: [
        {
            required: true,
            message: "상품명을 입력해주세요.",
            trigger: ["input", "blur"],
        },
    ],
    price: [
        { required: true, message: "가격을 입력해주세요." },
        { type: "number", message: "가격은 숫자여야 합니다." },
    ],
};

const columns = [
    {
        title: "상품코드",
        key: "product_key",
        resizable: true,
    },
    {
        title: "상품명",
        key: "name",
        resizable: true,
    },
    {
        title: "가격",
        key: "price",
        resizable: true,
        render(row: Product) {
            return common.formatNumberWithCommas(row.price);
        },
    },
    {
        title: "상태",
        key: "status",
        resizable: true,
        render(row: ProductGroup) {
            if (!row.status) {
                return "판매중";
            } else {
                // TODO : 아직은 상태 값이 정해지지 않았음.
                return row.status;
            }
        },
    },
    {
        title: "상세보기",
        key: "actions",
        render(row: ProductGroup) {
            return h(
                NButton,
                {
                    strong: true,
                    tertiary: true,
                    size: "small",
                    onClick: () => displayProductGroupDetails(row, false),
                },
                { default: () => "상세" }
            );
        },
    },
    {
        title: "정보 수정",
        key: "actions",
        render(row: ProductGroup) {
            return h(
                NButton,
                {
                    strong: true,
                    tertiary: true,
                    size: "small",
                    onClick: () => displayProductGroupDetails(row, true),
                },
                { default: () => "수정" }
            );
        },
    },
];

const itemColumns = [
    { title: "상품명", key: "name" },
    { title: "타입", key: "type" },
];

const selectedGroupItemColumns = [
    { title: "상품명", key: "name", width: 200 },
    {
        title: "삭제",
        key: "actions",
        width: 60,
        align: "center" as const,
        render(row: Product) {
            return h(
                NButton,
                {
                    strong: true,
                    tertiary: true,
                    size: "tiny",
                    type: "error",
                    onClick: () => removeProductFromGroup(row.SK!, false),
                },
                { default: () => "삭제" }
            );
        },
    },
];

const updateSelectedGroupItemColumns = [
    { title: "상품명", key: "name", width: 200 },
    {
        title: "삭제",
        key: "actions",
        width: 60,
        align: "center" as const,
        render(row: Product) {
            return h(
                NButton,
                {
                    strong: true,
                    tertiary: true,
                    size: "tiny",
                    type: "error",
                    onClick: () => removeProductFromGroup(row.SK!, true),
                },
                { default: () => "삭제" }
            );
        },
    },
];

async function wrappedGoToNextPage() {
    if (!hasNextPage.value) return;
}

async function wrappedGoToPreviousPage() {
    if (currentPage.value <= 1) return;
    await composableGoToPreviousPage();
}

function displayProductGroupDetails(productGroup: ProductGroup, isUpdate = false) {
    error.value = null;
    selectedProductGroup.value = productGroup;
    if (isUpdate) openEditModal(productGroup);
    else showDetailsModal.value = true;
}

function openEditModal(productGroup: ProductGroup) {
    editModel.value = { ...productGroup };
    if (!editModel.value.products) editModel.value.products = [];
    showEditModal.value = true;
    nextTick(() => {
        editFormRef.value?.restoreValidation();
    });
}

function closeDetailsModal() {
    showDetailsModal.value = false;
}

function onDetailsModalClose() {}

function onGroupRegistrationModalClose() {
    showGroupRegistrationModal.value = false;
    isGroupRegistering.value = false;
    tempSelectedOrgProductId.value = null;
}

function closeEditModal() {
    showEditModal.value = false;
}

function onEditModalClose() {
    editModel.value = {
        SK: "",
        group_id: "",
        product_key: "",
        name: "",
        price: 0,
        description: "",
        status: "",
        products: [],
    };
    isUpdating.value = false;
}

async function fetchOrganizationProducts() {
    orgProductLoading.value = true;
    try {
        const result = await getOrganizationProductsCallable();
        if (common.evalFunctionResult(result) && result.data) {
            const data = common.getItemListFromFunctionResult(result);
            organizationProducts.value = data as Product[];
        } else {
            notification.error({
                title: "오류",
                content: `상품 목록 로드 실패: ${common.getResultError(result)}`,
                duration: 3000,
            });
            organizationProducts.value = [];
        }
    } catch (error: any) {
        notification.error({
            title: "오류",
            content: `상품 목록 로드 중 예외 발생: ${error.message}`,
            duration: 3000,
        });
        organizationProducts.value = [];
    } finally {
        orgProductLoading.value = false;
    }
}

function openGroupRegistrationModal() {
    groupRegistrationModel.value = {
        product_key: "",
        name: "",
        price: null,
        description: "",
        products: [],
    };
    tempSelectedOrgProductId.value = null;
    groupRegistrationFormRef.value?.restoreValidation();
    showGroupRegistrationModal.value = true;
}

function addSelectedProductToGroup(isEdit: boolean = false) {
    if (!tempSelectedOrgProductId.value) return;
    const productToAdd = organizationProducts.value.find((p) => p.SK === tempSelectedOrgProductId.value);
    if (productToAdd) {
        if (!isEdit) {
            if (!groupRegistrationModel.value.products.find((p) => p.SK === productToAdd.SK)) {
                groupRegistrationModel.value.products.push({ ...productToAdd });
            } else {
                message.warning("이미 추가된 상품입니다.");
            }
        } else {
            if (!editModel.value.products.find((p) => p.SK === productToAdd.SK)) {
                editModel.value.products.push({ ...productToAdd });
            } else {
                message.warning("이미 추가된 상품입니다.");
            }
        }
    }
    tempSelectedOrgProductId.value = null;
}

function removeProductFromGroup(productSK: string, isEdit: boolean = false) {
    if (!isEdit) {
        groupRegistrationModel.value.products = groupRegistrationModel.value.products.filter((p) => p.SK !== productSK);
    } else {
        editModel.value.products = editModel.value.products.filter((p) => p.SK !== productSK);
    }
}

async function handleGroupRegistrationSubmit() {
    try {
        await groupRegistrationFormRef.value?.validate();
    } catch (errors) {
        message.error("입력 내용을 확인해주세요.");
        return;
    }

    if (groupRegistrationModel.value.products.length === 0) {
        message.error("포함할 상품을 하나 이상 추가해주세요.");
        return;
    }
    isGroupRegistering.value = true;
    try {
        const productsForPayload = groupRegistrationModel.value.products.map((p) => ({
            ...p,
        }));

        const payload: Partial<ProductGroup> = {
            product_key: groupRegistrationModel.value.product_key,
            name: groupRegistrationModel.value.name,
            price: Number(groupRegistrationModel.value.price),
            description: groupRegistrationModel.value.description,
            products: productsForPayload,
        };

        const result = await addProductGroupCallable(payload);

        if (common.evalFunctionResult(result)) {
            message.success("상품이 성공적으로 등록되었습니다.");
            showGroupRegistrationModal.value = false;
            await wrappedRefreshProductGroups();
        } else {
            notification.error({
                title: "등록 실패",
                content: `상품 등록 중 오류 발생: ${common.getResultError(result) || "알 수 없는 오류"}`,
                duration: 3000,
            });
        }
    } catch (err: any) {
        console.error("상품 등록 API 호출 실패:", err);
        notification.error({
            title: "등록 실패",
            content: `상품 등록 중 심각한 오류 발생: ${err.message || "서버 통신 오류"}`,
            duration: 3000,
        });
    } finally {
        isGroupRegistering.value = false;
    }
}

async function handleUpdateSubmit() {
    try {
        await editFormRef.value?.validate();
    } catch (errors) {
        message.error("입력 내용을 확인해주세요.");
        return;
    }

    if (!editModel.value.SK && !editModel.value.group_id) {
        message.error("수정할 상품 정보가 올바르지 않습니다.");
        return;
    }
    isUpdating.value = true;
    try {
        const payload = { ...editModel.value };
        const result = await updateProductGroupCallable(payload as ProductGroup);

        if (common.evalFunctionResult(result)) {
            message.success("상품 정보가 성공적으로 수정되었습니다.");
            closeEditModal();
            await wrappedRefreshProductGroups();
        } else {
            notification.error({
                title: "수정 실패",
                description: `상품 정보 수정 중 오류 발생: ${common.getResultError(result) || "알 수 없는 오류"}`,
                duration: 3000,
            });
        }
    } catch (err: any) {
        console.error("상품 수정 API 호출 실패:", err);
        notification.error({
            title: "수정 실패",
            description: `상품 정보 수정 중 심각한 오류 발생: ${err.message || "서버 통신 오류"}`,
            duration: 3000,
        });
    } finally {
        isUpdating.value = false;
    }
}

onMounted(async () => {
    await fetchOrganizationProducts();
    wrappedRefreshProductGroups();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("div", {
      style: {"height":"auto"},
      key: componentKey.value
    }, [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "개인용 상품 관리", -1)
                ])),
                _: 1
              }),
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _withDirectives(_createVNode(Loading, null, null, 512), [
                [_vShow, _unref(loading)]
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: openGroupRegistrationModal,
                  class: "action-button"
                }, "신규 상품 등록"),
                (_unref(listLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "상품 목록을 불러오는 중..."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        (_unref(productGroups).length > 0)
                          ? (_openBlock(), _createBlock(_unref(NDataTable), {
                              key: 0,
                              columns: columns,
                              data: _unref(productGroups),
                              pagination: false,
                              bordered: true
                            }, null, 8, ["data"]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_5, "등록된 상품이 없습니다."))
                      ]),
                      (_unref(productGroups).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToPreviousPage,
                              disabled: _unref(currentPage) === 1,
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode(" 이전 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"]),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToNextPage,
                              disabled: !_unref(hasNextPage)
                            }, {
                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                _createTextVNode(" 다음 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NModal), {
            show: showDetailsModal.value,
            "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showDetailsModal).value = $event)),
            preset: "card",
            style: {"width":"600px"},
            title: "진단 상품 상세 정보",
            onAfterLeave: onDetailsModalClose
          }, {
            default: _withCtx(() => [
              (selectedProductGroup.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 1,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), { label: "상품코드" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProductGroup.value.product_key), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "상품명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProductGroup.value.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "가격" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProductGroup.value.price?.toLocaleString()) + " 원 ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "설명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProductGroup.value.description || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProductGroup.value.status ? selectedProductGroup.value.status : "판매중"), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _cache[23] || (_cache[23] = _createElementVNode("h4", { style: {"margin-top":"20px","margin-bottom":"10px"} }, "포함된 상품 목록", -1)),
                    (selectedProductGroup.value.products && selectedProductGroup.value.products.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_unref(NDataTable), {
                            columns: itemColumns,
                            data: selectedProductGroup.value.products,
                            pagination: false,
                            bordered: true,
                            size: "small"
                          }, null, 8, ["data"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, "포함된 상품이 없습니다.")),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(NButton), {
                        onClick: closeDetailsModal,
                        type: "primary"
                      }, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createTextVNode("닫기")
                        ])),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(NModal), {
            show: showGroupRegistrationModal.value,
            "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((showGroupRegistrationModal).value = $event)),
            preset: "card",
            style: {"width":"700px"},
            title: "신규 상품 등록",
            onAfterLeave: onGroupRegistrationModalClose
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NForm), {
                ref_key: "groupRegistrationFormRef",
                ref: groupRegistrationFormRef,
                model: groupRegistrationModel.value,
                rules: groupRegistrationRules,
                "label-placement": "left",
                "label-width": "auto",
                "require-mark-placement": "right-hanging"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NFormItem), {
                    label: "상품코드",
                    path: "product_key"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: groupRegistrationModel.value.product_key,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((groupRegistrationModel.value.product_key) = $event)),
                        placeholder: "상품코드"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "상품명",
                    path: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: groupRegistrationModel.value.name,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((groupRegistrationModel.value.name) = $event)),
                        placeholder: "상품명"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "가격",
                    path: "price"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputNumber), {
                        value: groupRegistrationModel.value.price,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((groupRegistrationModel.value.price) = $event)),
                        placeholder: "가격",
                        style: {"width":"100%"},
                        min: 0
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "설명",
                    path: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: groupRegistrationModel.value.description,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((groupRegistrationModel.value.description) = $event)),
                        type: "textarea",
                        placeholder: "상품에 대한 설명 (선택 사항)"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "상품 선택",
                    path: "products"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        vertical: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NSpace), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NSelect), {
                                value: selectedProductCategory.value,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((selectedProductCategory).value = $event)),
                                placeholder: "카테고리를 선택하세요",
                                options: productCategories.value,
                                "label-field": "label",
                                "value-field": "value",
                                clearable: "",
                                style: {"width":"180px"}
                              }, null, 8, ["value", "options"]),
                              _createVNode(_unref(NSelect), {
                                value: tempSelectedOrgProductId.value,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((tempSelectedOrgProductId).value = $event)),
                                placeholder: "상품을 선택하세요",
                                options: organizationProductsOptions.value,
                                "label-field": "name",
                                "value-field": "SK",
                                filterable: "",
                                clearable: "",
                                disabled: !selectedProductCategory.value,
                                style: {"width":"400px"}
                              }, null, 8, ["value", "options", "disabled"]),
                              _createVNode(_unref(NButton), {
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (addSelectedProductToGroup(false))),
                                disabled: !tempSelectedOrgProductId.value
                              }, {
                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                  _createTextVNode("추가")
                                ])),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          (orgProductLoading.value && organizationProducts.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 상품 목록을 불러오는 중입니다... "))
                            : (!orgProductLoading.value && organizationProducts.value.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 등록된 상품이 없습니다. 먼저 상품을 등록해주세요. "))
                              : _createCommentVNode("", true),
                          (groupRegistrationModel.value.products.length > 0)
                            ? (_openBlock(), _createBlock(_unref(NDataTable), {
                                key: 2,
                                columns: selectedGroupItemColumns,
                                data: groupRegistrationModel.value.products,
                                pagination: false,
                                bordered: true,
                                size: "small",
                                style: {"margin-top":"10px"}
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(NButton), {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (showGroupRegistrationModal.value = false)),
                      type: "tertiary",
                      style: {"margin-right":"10px"}
                    }, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode("취소")
                      ])),
                      _: 1
                    }),
                    _createVNode(_unref(NButton), {
                      type: "primary",
                      onClick: handleGroupRegistrationSubmit,
                      loading: isGroupRegistering.value
                    }, {
                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createTextVNode("등록")
                      ])),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(NModal), {
            show: showEditModal.value,
            "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((showEditModal).value = $event)),
            preset: "card",
            style: {"width":"700px"},
            title: "상품 정보 수정",
            onAfterLeave: onEditModalClose
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NForm), {
                ref_key: "editFormRef",
                ref: editFormRef,
                model: editModel.value,
                rules: editRules,
                "label-placement": "left",
                "label-width": "auto",
                "require-mark-placement": "right-hanging"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NFormItem), {
                    label: "상품 코드",
                    path: "product_key"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: editModel.value.product_key,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((editModel.value.product_key) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "상품명",
                    path: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: editModel.value.name,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((editModel.value.name) = $event)),
                        placeholder: "상품명"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "가격",
                    path: "price"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputNumber), {
                        value: editModel.value.price,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((editModel.value.price) = $event)),
                        placeholder: "가격",
                        style: {"width":"100%"},
                        min: 0
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "설명",
                    path: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: editModel.value.description,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((editModel.value.description) = $event)),
                        type: "textarea",
                        placeholder: "상품에 대한 설명"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "상품 선택",
                    path: "products"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        vertical: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NSpace), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NSelect), {
                                value: selectedProductCategory.value,
                                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((selectedProductCategory).value = $event)),
                                placeholder: "카테고리를 선택하세요",
                                options: productCategories.value,
                                "label-field": "label",
                                "value-field": "value",
                                clearable: "",
                                style: {"width":"180px"}
                              }, null, 8, ["value", "options"]),
                              _createVNode(_unref(NSelect), {
                                value: tempSelectedOrgProductId.value,
                                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((tempSelectedOrgProductId).value = $event)),
                                placeholder: "상품을 선택하세요",
                                options: organizationProductsOptions.value,
                                "label-field": "name",
                                "value-field": "SK",
                                filterable: "",
                                clearable: "",
                                disabled: !selectedProductCategory.value,
                                style: {"width":"400px"}
                              }, null, 8, ["value", "options", "disabled"]),
                              _createVNode(_unref(NButton), {
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (addSelectedProductToGroup(true))),
                                disabled: !tempSelectedOrgProductId.value
                              }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createTextVNode("추가")
                                ])),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          (editModel.value.products.length > 0)
                            ? (_openBlock(), _createBlock(_unref(NDataTable), {
                                key: 0,
                                columns: updateSelectedGroupItemColumns,
                                data: editModel.value.products,
                                pagination: false,
                                bordered: true,
                                size: "small",
                                style: {"margin-top":"10px"}
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_unref(NButton), {
                  onClick: closeEditModal,
                  type: "tertiary",
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createTextVNode("취소")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(NButton), {
                  type: "primary",
                  onClick: handleUpdateSubmit,
                  loading: isUpdating.value
                }, {
                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                    _createTextVNode("확인")
                  ])),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})